export default __webpack_public_path__ + "static/media/gobienodig.8a678620.png";